import React from 'react';
import PropTypes from 'prop-types';

import { ButtonRound } from '@ontruck/orc';
import { StyledFloatingButton } from './styled';

const RemoveStopButton = ({ onClick, ...props }) => {
  return (
    <StyledFloatingButton {...props}>
      <ButtonRound skin="primary" size="S" onClick={onClick} icon="close" shadow />
    </StyledFloatingButton>
  );
};

RemoveStopButton.propTypes = {
  onClick: PropTypes.func.isRequired,
};

export default RemoveStopButton;
